const state = {
  oldDeptId: "",
  inDeptUser: [],
  treeData: [],
  userList: {},
  userCount : 0,
  selectedUsers: [],
  selectedDepts: []
};
const actions = {
  setOrgTree({ state, commit }, data) {
    let rootNode = data.rootNode;
    let treeList = data.treeList;
    let rootNodeInfo = null;
    let nodeListData = [];
    let searchCondition = data.searchCondition;

    if (rootNode !== null && rootNode !== undefined) {
      rootNodeInfo = {
        id: rootNode.deptId || rootNode.htagCategoryId,
        label: rootNode.deptName || rootNode.htagCategoryName,
        level: rootNode.level
      };
    }
    if (treeList !== null && treeList !== undefined) {
      treeList.forEach(function(item, index, arr) {
        let node = item;
        let childYn = node.childYn || node.level;
        let nodeInfo = {
          id: node.deptId || node.htagCategoryId,
          label: node.deptName || node.htagCategoryName,
          level: node.level
        };
        if (searchCondition === null || searchCondition === undefined) {
          if (childYn > 0) {
            nodeInfo.children = null;
          }
        }
        nodeListData.push(nodeInfo);
      });
    }
    if (rootNode !== null && rootNode !== undefined) {
      rootNodeInfo.children = nodeListData;
    }
    if (data.parentNode !== null) {
      data.parentNode.children = nodeListData;
    } else {
      commit("resetTreeList", {
        rootNodeInfo: rootNodeInfo,
        nodeListData: nodeListData
      });
    }
  },
  addUser({ state, commit }, payload) {
    let addkUsers = payload.addkUsers;
    let selectedUsers = payload.selectedUsers;

    addkUsers.forEach(function (user, index, arr) {
      if (selectedUsers.findIndex(i => i.userId === user.userId) > -1) {
        alert(user.userName + " 은(는) 이미 존재합니다.");
      } else {
        selectedUsers.push(user);
      }
    });
    // addkUsers.forEach(function(user, index, arr) {
    //   if (selectedUsers.includes(user)) {
    //     alert(user.userName + " 은(는) 이미 존재합니다.");
    //   } else {
    //     //this.selectedUsers.push(user);
    //     selectedUsers.push(user);
    //   }
    // });
    commit("setSelectedUsers", selectedUsers);
  },
  removeUser({ state, commit }, payload) {
    let removeUsers = payload.removeUsers;
    let selectedUsers = payload.selectedUsers;

    removeUsers.forEach(function(user, index, arr) {
      selectedUsers = selectedUsers.filter(
        users => users.userId !== user.userId
      );
    });
    commit("setSelectedUsers", selectedUsers);
  },
  addDept({ state, commit }, payload) {
    let addDepts = payload.addDepts;
    let selectedDepts = payload.selectedDepts;

    addDepts.forEach(function(dept, index, arr) {
      if (selectedDepts.includes(dept)) {
        alert(dept.label + " 은(는) 이미 존재합니다.");
      } else {
        //this.selectedUsers.push(user);
        selectedDepts.push(dept);
      }
    });
    commit("setSelectedDepts", selectedDepts);
  },
  removeDept({ state, commit }, payload) {
    let removeDepts = payload.removeDepts;
    let selectedDepts = payload.selectedDepts;

    removeDepts.forEach(function(dept, index, arr) {
      selectedDepts = selectedDepts.filter(depts => depts.id !== dept.id);
    });
    commit("setSelectedDepts", selectedDepts);
  }
};

const mutations = {
  resetTreeList(state, payload) {
    if (payload !== null) {
      if (payload.rootNodeInfo !== null) {
        state.treeData.push(payload.rootNodeInfo);
      } else {
        state.treeData = payload.nodeListData;
      }
      //state.treeData = payload;
    } else {
      state.treeData = [];
    }
  },
  setTreeOfUserList(state, payload) {
    if (payload !== null) {
      state.userList = payload;
      state.userCount = payload.length;
    } else {
      state.userList = {};
      state.userCount = 0;
    }
  },
  setNodeOfDeptInfo(state, payload) {
    if (payload !== null) {
      state.userList = payload;
    } else {
      state.userList = {};
    }
  },
  setSelectedUsers(state, payload) {
    if (payload !== null) {
      state.selectedUsers = payload;
    } else {
      state.selectedUsers = [];
    }
  },
  setSelectedDepts(state, payload) {
    if (payload !== null) {
      state.selectedDepts = payload;
    } else {
      state.selectedDepts = [];
    }
  }
};
const getters = {};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
};



// WEBPACK FOOTER //
// ./src/js/store/module/tree/tree.js